import React from 'react';
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import ReportContent from "./content/report-content.jsx";
import {hasVisibleReportColumns} from "../../../../utils/report-columns.js";

const Content = ({reportData, data, entity, title, collapsed, printComponentRef, setLoading, details, tableColumns}) => {
    return (
        <>
            {
                reportData && data > 0 && (
                    <PrintTemplate entity={entity} title={title} ref={printComponentRef} setIsPrinting={setLoading}>
                        <div id="filters-print" className={'transform !-translate-y-[8.5px]'}></div>
                        <div className="print:border-b print:border-gray-200 print:mb-6 print:w-full"/>

                        <div className={`w-full ${hasVisibleReportColumns(tableColumns) ? "mt-[25px]" : "mt-[-4px]"} print:mt-[0]`}>
                            <ReportContent
                                data={reportData}
                                collapsed={collapsed}
                                details={details}
                                tableColumns={tableColumns}
                            />
                        </div>
                    </PrintTemplate>
                )
            }
        </>
    );
};

export default Content;